import { NextSeo, ArticleJsonLd } from "next-seo";
import type { PostOrPage } from "@tryghost/content-api";

const blogTitle = "Crayo AI - Blog";
const blogDescription =
  "Crayo AI – your gateway to creating viral TikTok clips in seconds! Harness the power of AI to turn your ideas into captivating videos effortlessly. Join the new era of content creation powered by AI.";
const blogUrl = "https://crayo.ai/blog";
const blogSocialImage = "https://crayo-ai.ghost.io/content/images/2025/02/crayo.jpg";

export const BlogSeo = ({ post }: { post?: PostOrPage }) => (
  <>
    <NextSeo
      title={post?.title}
      titleTemplate="%s — Crayo AI Clip Creation Tool"
      defaultTitle={blogTitle}
      description={post?.meta_description ?? blogDescription}
      canonical={post ? `${blogUrl}/${post.slug}` : blogUrl}
      openGraph={{
        type: post ? "article" : "website",
        siteName: "Crayo",
        locale: "en_US",
        images: [
          {
            url: post?.feature_image ?? blogSocialImage,
            alt: post ? `${post?.slug.replace("-", " ")} feature image` : blogTitle,
          },
        ],
      }}
      twitter={{
        cardType: "summary_large_image",
        handle: "@Crayoai",
        site: "https://crayo.ai",
      }}
      robotsProps={{
        maxImagePreview: "large",
      }}
    />
    <ArticleJsonLd
      type={post ? "BlogPosting" : "Blog"}
      url={post ? `${blogUrl}/${post.slug}` : blogUrl}
      title={post?.title ?? blogTitle}
      description={post?.meta_description ?? blogDescription}
      images={[post?.feature_image ?? blogSocialImage]}
      datePublished={post?.published_at ?? "2024-02-01T00:00:00.000Z"}
      dateModified={post?.published_at ?? "2024-02-01T00:00:00.000Z"}
      authorName={{ name: "Crayo", url: "https://crayo.ai" }}
    />
  </>
);
